<template>
  <Fieldset
    legend="Spiele"
    :toggleable="true"
    :collapsed="gameViewCollapsed"
    @toggle="toogleGameView()"
    style="min-width: 300px"
  >
    <div v-if="totalGameDaysCount > 0">
      <Paginator
        v-model:first="currentIndex"
        :rows="1"
        :pageLinkSize="totalGameDaysCount"
        template="PageLinks"
        :totalRecords="totalGameDaysCount"
        @page="onPage($event)"
      >
      </Paginator>
      <h4>{{ currentGameDay.spieltag }}. Spieltag</h4>
      <div
        class="align-items-center justify-content-center gamesView"
        style="display: flex"
      >
        <DataTable
          class="p-datatable-sm"
          :value="currentGameDay.alleSpiele"
          :rowClass="rowClass"
          responsiveLayout="stack"
          breakpoint="550px"
        >
          <Column header="Datum">
            <template #body="slotProps">
              {{ slotProps.data.datum }}
              {{
                slotProps.data.uhrzeit && slotProps.data.uhrzeit != null
                  ? slotProps.data.uhrzeit
                  : ""
              }}
            </template>
          </Column>
          <Column field="heimmannschaft" header="Heim" />
          <Column field="ergebnis" header="Ergebnis" style="text-align: center" />
          <Column field="gastmannschaft" header="Gast" />
          <Column header="Spielstatus">
            <template #body="slotProps">
              {{ translateGameStatus(slotProps.data) }}
            </template>
          </Column>
          <Column header="">
            <template #body="slotProps">
              <Button
                v-if="canShowGame(slotProps.data)"
                style="margin: 2px 2px"
                icon="pi pi-eye"
                v-tooltip.top="'Details'"
                class="p-button-rounded p-button-success mb2"
                @click="showGame(slotProps.data)"
              />
              <Button
                v-if="userHasRole('LEAGUE_MANAGER')"
                style="margin: 2px 2px"
                icon="pi pi-pencil"
                v-tooltip.top="'Editieren'"
                class="p-button-rounded p-button-warning mb2"
                @click="editGame(slotProps.data)"
              />
              <Button
                v-else-if="
                  userHasRole('LEAGUE_MAINTAINER') && canEditGameDate(slotProps.data)
                "
                style="margin: 2px 2px"
                icon="pi pi-calendar"
                v-tooltip.top="'Datum ändern'"
                class="p-button-rounded p-button-warning mb2"
                @click="editGameDate(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
    <div v-else>
      <ProgressSpinner style="margin-top: 20px" />
    </div>
  </Fieldset>
  <Dialog v-model:visible="displayGameDateDialog" :closable="false">
    <template #header>
      <h3 style="max-width: 400px">
        Datumsänderung des Spiels am {{ currentGame.representation }}
      </h3>
    </template>
    <div
      class="flex flex-column card-container justify-content-center"
      style="max-width: 800px"
    >
      <Calendar
        v-model="newGameDate"
        dateFormat="dd.mm.yy"
        :showTime="true"
        hourFormat="24"
        :manualInput="true"
        inline
      />
    </div>
    <template #footer>
      <Button
        label="Speichern"
        icon="pi pi-check"
        class="p-button-text"
        @click="closeGameDateDialog(true)"
      />
      <Button label="Abbrechen" icon="pi pi-times" @click="closeGameDateDialog(false)" />
    </template>
  </Dialog>
</template>

<script>
import ServerConnection from "../../services/ServerConnection/ServerConnection";
import FailureHandler from "../../services/ServerConnection/FailureHandler";
import UserPermissionsService from "../../services/UserPermissionsService/UserPermissionsService";
import Paginator from "primevue/paginator";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";
import Fieldset from "primevue/fieldset";
import Dialog from "primevue/dialog";
import Calendar from "primevue/calendar";
export default {
  name: "AdminGameDayView",
  components: {
    Calendar,
    Paginator,
    DataTable,
    Dialog,
    Column,
    Button,
    ProgressSpinner,
    Fieldset,
  },
  data() {
    return {
      gameDays: [],
      currentGameDay: {},
      oldMannschaftId: undefined,
      oldLeagueId: undefined,
      currentIndex: -1,
      gameViewCollapsed: this.collapsed,
      displayGameDateDialog: false,
      currentGame: undefined,
      newGameDate: undefined,
    };
  },
  computed: {
    totalGameDaysCount() {
      return this.gameDays ? this.gameDays.length : 0;
    },
  },
  props: {
    mannschaft: { require: false },
    league: { require: false },
    gameDayNumber: { require: false, default: -1 },
    collapsed: { require: false, default: true },
  },
  mounted() {
    this.loadGameDays();
  },
  watch: {
    mannschaft() {
      this.loadGameDays();
    },
    league() {
      this.loadGameDays();
    },
  },
  methods: {
    toogleGameView() {
      this.gameViewCollapsed = !this.gameViewCollapsed;
      if (!this.gameViewCollapsed) {
        this.loadGameDays();
      }
    },
    loadGameDays() {
      var response = null;
      if (!this.gameViewCollapsed) {
        if (
          this.mannschaft &&
          this.mannschaft.id &&
          (!this.oldMannschaftId || this.oldMannschaftId != this.mannschaft.id)
        ) {
          this.oldMannschaftId = this.mannschaft.id;

          response = ServerConnection.get(
            "data/saison/current/mannschaft/" + this.mannschaft.id + "/games"
          );
        } else if (
          this.league &&
          this.league.id &&
          (!this.oldLeagueId || this.oldLeagueId != this.league.id)
        ) {
          this.oldLeagueId = this.league.id;
          response = ServerConnection.get(
            "data/saison/current/league/" + this.league.id + "/games"
          );
        }
        if (response != null) {
          response
            .then((response) => response.data)
            .then((data) => {
              this.gameDays = data;
              this.selectGameDay(this.requestedGameDayIndex());
            })
            .catch((error) => {
              FailureHandler.handleServerFailure(this.$router, error);
            });
        }
      }
    },
    requestedGameDayIndex() {
      var storedCurrentIndex = localStorage.getItem("currentGameDayIndex");
      if (storedCurrentIndex) {
        localStorage.removeItem("currentGameDayIndex");
        return parseInt(storedCurrentIndex);
      }
      if (this.gameDayNumber && this.gameDayNumber > 0) {
        return this.gameDayNumber - 1;
      }
      return -1;
    },
    selectGameDay(index) {
      var validIndex = this.isSelectableIndex(index)
        ? index
        : this.fallbackGameDayIndex();
      this.currentIndex = validIndex;
      this.currentGameDay = this.gameDays[validIndex];
    },
    isSelectableIndex(index) {
      return index >= 0 && index < this.gameDays.length;
    },
    fallbackGameDayIndex() {
      if (this.isSelectableIndex(this.currentIndex)) {
        return this.currentIndex;
      }
      var nextGameDay = this.gameDays.find((gameDay) => gameDay.istNaechterSpieltag);
      return nextGameDay ? this.gameDays.indexOf(nextGameDay) : 0;
    },
    editGame(data) {
      localStorage.setItem("currentGameDayIndex", this.currentIndex);
      this.$router.push("/game/edit/" + data.id);
    },
    editGameDate(data) {
      localStorage.setItem("currentGameDayIndex", this.currentIndex);
      this.newGameDate = new Date(data.date);
      this.currentGame = data;
      this.displayGameDateDialog = true;
    },
    closeGameDateDialog(save) {
      if (save) {
        ServerConnection.put(
          "data/game/" + this.currentGame.id + "/date",
          JSON.stringify(this.newGameDate)
        )
          .then(() => {
            this.loadGameDays();
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
      this.displayGameDateDialog = false;
    },
    canShowGame(data) {
      return (
        data.heimmannschaft &&
        data.heimmannschaft.length > 0 &&
        data.gastmannschaft &&
        data.gastmannschaft.length > 0
      );
    },
    showGame(data) {
      localStorage.setItem("currentGameDayIndex", this.currentIndex);
      this.$router.push("/game/view/" + data.id);
    },
    ownGame(data) {
      return (
        this.mannschaft &&
        this.mannschaft.id &&
        (data.heimmannschaft === this.mannschaft.name ||
          data.gastmannschaft === this.mannschaft.name)
      );
    },
    canEditGameDate(data) {
      return (
        this.canShowGame(data) &&
        ["ToPlay", "InDiscussion", "PostPoned"].find((d) => d == data.status)
      );
    },
    statusAllowsEditing(data) {
      if (data && data.status) {
        switch (data.status) {
          case "ToPlay":
          case "BeingPlayed":
          case "WaitingForResults":
          case "WaitingForImage":
            return true;
          default:
            return false;
        }
      }
      return false;
    },
    gamePlayed(data) {
      return data.ergebnis && data.ergebnis != " : ";
    },
    rowClass(data) {
      return this.ownGame(data) ? "owngame" : null;
    },
    onPage(event) {
      this.currentIndex = event.page;
      this.currentGameDay = this.gameDays[event.page];
      this.$emit("update:gameDayViewIndex", this.currentIndex);
    },
    translateGameStatus(game) {
      if (game && game.status) {
        switch (game.status) {
          case "ToPlay":
            return "Zu spielen";
          case "BeingPlayed":
            return "Wird gerade gespielt";
          case "WaitingForResults":
            return "Noch kein Endergebnis";
          case "WaitingForImage":
            return "Noch kein Bild des Endergebnisses";
          case "WaitingForHomeApproval":
            return "In Bestätigung durch Heim";
          case "InDiscussion":
            return "In Abstimmung";
          case "WaitingForGuestApproval":
            return "In Bestätigung durch Gast";
          case "WaitingForGameManagerApproval":
            return "In Kontrolle durch Spielleiter";
          case "Played":
            return "Gespielt";
          case "PostPoned":
            return "Verlegt";
          case "Unrated":
            return "Keine Wertung";
          case "ChangeRequested":
            return "Änderung beim Gegner angefragt";
        }
      }
      return "";
    },
    formatDate(data) {
      if (data && data.length > 0) {
        var date = new Date(data);
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var hour = date.getHours();
        var minutes = date.getMinutes();
        return (
          (day < 10 ? "0" + day : day) +
          "." +
          (month < 10 ? "0" + month : month) +
          "." +
          date.getFullYear() +
          " " +
          (hour < 10 ? "0" + hour : hour) +
          ":" +
          (minutes < 10 ? "0" + minutes : minutes) +
          " Uhr"
        );
      }
      return "";
    },
    userHasRole(role) {
      return UserPermissionsService.userHasRole(
        role,
        "league",
        this.league && this.league.id ? this.league.id : undefined
      );
    },
  },
};
</script>

<style lang="css">
.owngame {
  background-color: #b9c4ff !important;
}
@media (max-width: 550px) {
  .p-datatable .p-datatable-tbody > tr > td {
    padding: 2px 7px !important;
  }
  .p-datatable[pv_id_2] .p-datatable-tbody > tr > td:is(:last-child) {
    justify-content: flex-end !important;
  }
  .gamesView {
    display: block !important;
  }

  /* Darken the line between the entries in mobile mode */
  .p-datatable .p-datatable-tbody > tr > td {
    text-align: right !important;
    border: 1px solid #555;
    border-width: 0 0 2px 0;
  }
  /* Enlarge distance between each entry in mobile mode */
  .p-datatable .p-datatable-tbody > tr > td:is(:last-child) {
    margin-bottom: 0.7rem;
    padding-bottom: 1rem;
  }
}
</style>
